import { Component } from 'react';

import { NumberValueFormatter } from '@gogame/intl-ts';
import { ChevronLeftIcon, ChevronRightIcon } from '@gogame/ui/Icon';
import IconButton from '@gogame/ui/IconButton';
import { Select } from '@gogame/ui/Select';

//todo use overwrited select
import LegacyBox from '../Box';
import LegacyText from '../Text';

const DEFAULT_LIMITS = [
  {
    name: '25',
    id: 25,
  },
  {
    name: '50',
    id: 50,
  },
  {
    name: '100',
    id: 100,
  },
];

class LegacyPagination extends Component {
  static defaultProps = {
    limits: [...DEFAULT_LIMITS],
    width: '164px',
  };

  state = {
    totalPerLimit: 0,
  };

  handlePrevPage = () => {
    const { offset, limit } = this.props;
    this.props.onChange({ offset: Math.max(offset - limit, 0), limit });
  };

  handleNextPage = () => {
    const { offset, limit } = this.props;
    this.props.onChange({ offset: offset + limit, limit });
  };

  handlePageChange = (_e, offset) => {
    const { limit } = this.props;
    this.props.onChange({ offset, limit });
  };

  handleLimitChange = (_e, value) => {
    this.props.onChange({ limit: value, offset: 0 });
  };

  render() {
    const { offset, limit, count, limits, style } = this.props;
    const totalPerLimit = Math.min(offset + limit, count);
    const totalPages = Math.ceil(count / limit);
    const pages = Array(totalPages)
      .fill(1)
      .map((_, i) => ({
        id: i * limit,
        name: `${i + 1}`,
      }));

    return (
      <LegacyBox
        justifyContent={'flex-end'}
        align={'center'}
        gutter={16}
        style={style}
        data-cy={'pagination'}
      >
        <LegacyText>
          <NumberValueFormatter.Decimal
            value={count}
            data-cy={'countRecords'}
          />{' '}
          records
        </LegacyText>
        <LegacyBox gutter={8} align={'center'}>
          <LegacyText variant={'body2'}>Show:</LegacyText>
          <Select
            padding={'8px'}
            width={'90px'}
            value={limit}
            variant={'outlined'}
            onChange={this.handleLimitChange}
            options={limits}
            dense={true}
            withFilter={false}
            data-cy={'showSelect'}
          />
        </LegacyBox>
        <LegacyBox align={'center'} gutter={8}>
          <LegacyText>current page:</LegacyText>
          <Select
            padding={'8px'}
            width={'90px'}
            value={offset}
            variant={'outlined'}
            onChange={this.handlePageChange}
            options={pages}
            dense={true}
            withFilter={false}
            data-cy={'currentPageSelect'}
            disabled={!pages.length}
          />
          <LegacyText>
            &nbsp;of <NumberValueFormatter.Decimal value={totalPages} />
          </LegacyText>
        </LegacyBox>
        <LegacyBox gutter={8}>
          <IconButton
            style={{ width: '46px', height: '46px' }}
            icon={<ChevronLeftIcon />}
            onClick={this.handlePrevPage}
            disabled={offset <= 0}
            data-cy={'prevPage'}
            tooltip={'Previous page'}
          />
          <IconButton
            style={{ width: '46px', height: '46px' }}
            icon={<ChevronRightIcon />}
            onClick={this.handleNextPage}
            disabled={totalPerLimit >= count}
            data-cy={'nextPage'}
            tooltip={'Next page'}
          />
        </LegacyBox>
      </LegacyBox>
    );
  }
}

export default LegacyPagination;
